// Bootstrap a global axios request interceptor so every API call carries an
// `X-Active-Center` header (read from localStorage). Backend's
// `get_current_user_with_role` reads this header and, if the user owns the
// chosen center, patches `user.center_id` for the rest of the request — so
// existing per-center scoping in dashboards / lists / KPIs Just Works™ when
// a multi-center CM/CA switches their active context.

import axios from 'axios';

export const ACTIVE_CENTER_STORAGE_KEY = 'activeCenterId';

let installed = false;

export function installAxiosActiveCenterInterceptor() {
  if (installed) return;
  installed = true;
  axios.interceptors.request.use((config) => {
    try {
      const cid = localStorage.getItem(ACTIVE_CENTER_STORAGE_KEY);
      if (cid) {
        config.headers = config.headers || {};
        config.headers['X-Active-Center'] = cid;
      }
    } catch (_e) {
      // localStorage unavailable (SSR / privacy mode) — fail silently
    }
    return config;
  });
}

export function setActiveCenterId(centerId) {
  if (!centerId) {
    localStorage.removeItem(ACTIVE_CENTER_STORAGE_KEY);
  } else {
    localStorage.setItem(ACTIVE_CENTER_STORAGE_KEY, centerId);
  }
}

export function getActiveCenterId() {
  try {
    return localStorage.getItem(ACTIVE_CENTER_STORAGE_KEY) || null;
  } catch (_e) {
    return null;
  }
}
